import { postApi } from 'util/api';

// eslint-disable-next-line import/prefer-default-export
export const add = async (data, auth) => {
  return postApi(
    '/auth/publicKeys',
    {
      clientId: data.clientId,
      keyValue: data.keyValue,
    },
    {
      userId: auth.id,
    }
  );
};
